import { formatCents } from '@src/common';
import { CartItem } from '@src/core/buyerApiClient';
import useTranslate from '@src/i18n/useTranslate';
import React, { PropsWithChildren } from 'react';
import ProductImage from '../ProductImage';
import { ProductName, SaleItem, SaleItemInfo, SaleItemLabelValue } from './styles';
import { dateBySellingMode } from '@src/common/checkout';

interface CartSaleItemProps extends PropsWithChildren {
  item: CartItem;
  showPlaceholderImage?: boolean;
}

const CartSaleItem = ({ item, showPlaceholderImage = false, children }: CartSaleItemProps) => {
  const { i18n } = useTranslate();

  return (
    <SaleItem key={item.id}>
      <ProductImage product={item.product} showPlaceholderImage={showPlaceholderImage} />

      <SaleItemInfo>
        <ProductName>{item.product.name}</ProductName>

        <SaleItemLabelValue>
          <p>{i18n('direct_link_summary_date_and_time')}</p>
          <p>{dateBySellingMode({ item, i18n })}</p>
        </SaleItemLabelValue>

        {item.tariffs.map((tariff) => (
          <SaleItemLabelValue key={tariff.tariff.id}>
            <p>
              {tariff.tariff.type.name} - {tariff.quantity}
            </p>
            <p>{formatCents(tariff.tariff.priceCents)}</p>
          </SaleItemLabelValue>
        ))}

        {item?.resources.map((saleResource) => (
          <SaleItemLabelValue key={saleResource.resource.name}>
            <p>{saleResource.resource.formattedName}</p>
            <p>{saleResource.minPriceCents ? formatCents(saleResource?.minPriceCents) : null}</p>
          </SaleItemLabelValue>
        ))}

        {item.additionals.map((saleAdditional) => (
          <SaleItemLabelValue key={saleAdditional.additional.id}>
            <p>
              {saleAdditional.additional.title} - {saleAdditional.quantity}
            </p>

            <p>{formatCents(saleAdditional.amountCents)}</p>
          </SaleItemLabelValue>
        ))}

        {children}
      </SaleItemInfo>
    </SaleItem>
  );
};

export default CartSaleItem;
